import { useEffect } from "react";

function useOutSideClick(ref, callback) {
  useEffect(() => {
    
    const handleClick = (event) => {
      var modal_start_x = document.querySelector('.in_modal').getBoundingClientRect().x;
      var modal_end_x = Number(document.querySelector('.in_modal').getBoundingClientRect().x) + Number(document.querySelector('.in_modal').getBoundingClientRect().width);
      var modal_start_y = document.querySelector('.in_modal').getBoundingClientRect().y;
      var modal_end_y = Number(document.querySelector('.in_modal').getBoundingClientRect().y) + Number(document.querySelector('.in_modal').getBoundingClientRect().height);

      //if(Number(event.clientX) >= Number(modal_start_x) && Number(event.clientX) <= Number(modal_end_x) && Number(event.clientY) >= Number(modal_start_y) && Number(event.clientY) <= Number(modal_end_y)){
      if(Number(event.clientX) >= Number(modal_start_x) && Number(event.clientX) <= Number(modal_end_x)){
        //[2025.03.01] - selectbox 때문에 Y좌표를 제외함.
        //위에 class포함는 Modal들은 아꺼지도록 함.
        //좌표안에 클릭이면 닫히지 않는다.
      }else if ((ref.current && !ref.current.contains(event.target))) {  
        //callback -> 닫히는 함수
        //callback?.();
      }
    };

    window.addEventListener("mousedown", handleClick);

    return () => window.removeEventListener("mousedown", handleClick);
  }, [ref, callback]);
}

export default useOutSideClick;